import { Transition, TransitionGroup } from 'react-transition-group';
import { useModalManager } from 'libs/modalManager';

// TODO: allow to customize duration per modal
const duration = 300;

export default function ModalContainer({ mountingGroup: mountingGroupArg }) {
  const { modals, closeModal } = useModalManager();

  return (
    <TransitionGroup>
      {Object.entries(modals).map(
        ([key, { component: Component, mountingGroup, props = {} }]) => {
          if (mountingGroupArg !== mountingGroup) {
            return null;
          }

          return (
            <Transition key={key} timeout={duration}>
              {(state) => (
                <Component
                  onClose={() => closeModal(key)}
                  {...props}
                  open={state !== "exiting" && state !== "exited"}
                />
              )}
            </Transition>
          );
        }
      )}
    </TransitionGroup>
  );
}
